import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class RBC_RESIDENTIAL_LANDLORD_CONSENT_Mapper extends BaseFormMapper<RBC_RESIDENTIAL_LANDLORD_CONSENT> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: RBC_RESIDENTIAL_LANDLORD_CONSENT,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as RBC_RESIDENTIAL_LANDLORD_CONSENT);

		return _formData;
	}

	MapValues(): Partial<RBC_RESIDENTIAL_LANDLORD_CONSENT> {
		return {};
	}
}

const Mappings: RBC_RESIDENTIAL_LANDLORD_CONSENT = {
	tenantName2: 'tenantPrintName2',
	tenantSignature: 'tenantSignature1',
	tenantSignature2: 'tenantSignature2',
	landlordSignature: 'landlordSignature1',
	landlordName: 'landlordPrintName',
	tenantName: 'tenantPrintName',
	year: 'year',
	dayOf: 'month',
	datedThe: 'date',
	payable: 'payable',
	commencingOn: 'commence',
	rent: 'rental',
	term: 'term',
	locatedAt: 'community',
	manufacturedHomeSiteNumber: 'Lease',
	leaseOfLand: 'Site',
	re: 'Tenant',
	to: 'Lender',
	from: 'Landlord',
	fax: 'FAX',
	telephone: 'telephone',
	email: 'email',
	address: 'address',
};

export interface RBC_RESIDENTIAL_LANDLORD_CONSENT {
	to: string;
	address: string;
	telephone: string;
	fax: string;
	email: string;
	re: string;
	leaseOfLand: string;
	manufacturedHomeSiteNumber: string;
	from: string;
	locatedAt: string;
	term: string;
	commencingOn: string;
	rent: string;
	payable: string;

	datedThe: string;
	dayOf: string;
	year: string;

	landlordSignature: string;
	tenantSignature: string;
	tenantSignature2: string;

	landlordName: string;
	tenantName: string;
	tenantName2: string;
}
